import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Scale } from "lucide-react";

export const SfgWeightFilter = ({ width, setWidth, widths, grade, setGrade, grades, count, totalKg }) => (
  <div data-testid="sfg-weight-filter" className="md:col-span-6 grid grid-cols-1 md:grid-cols-6 gap-3 border-t border-dashed border-slate-200 pt-3">
    <div className="flex gap-1">
      <Input
        data-testid="sfg-filter-width"
        type="number"
        inputMode="decimal"
        placeholder="SFG width (mm)"
        value={width}
        onChange={(e) => setWidth(e.target.value)}
        className="h-10 flex-1 min-w-0"
      />
      <Select value="" onValueChange={(v) => setWidth(v === "__all__" ? "" : v)}>
        <SelectTrigger data-testid="sfg-filter-width-select" className="h-10 w-12 px-2" aria-label="Pick a width" />
        <SelectContent>
          <SelectItem value="__all__" data-testid="sfg-width-opt-all">All widths</SelectItem>
          {widths.map((w) => (
            <SelectItem key={w} value={String(w)} data-testid={`sfg-width-opt-${w}`}>{w} mm</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <Select value={grade} onValueChange={setGrade}>
      <SelectTrigger data-testid="sfg-filter-grade" className="h-10">
        <SelectValue placeholder="SFG grade" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__all__">All SFG grades</SelectItem>
        {grades.map((g) => (
          <SelectItem key={g} value={g}>{g}</SelectItem>
        ))}
      </SelectContent>
    </Select>
    <div data-testid="sfg-filter-total" className="md:col-span-4 flex items-center gap-3 h-10 px-3 rounded-sm bg-slate-900 text-white">
      <Scale className="h-4 w-4 opacity-70" />
      <span className="text-[10px] tracking-[0.2em] uppercase opacity-70 font-semibold">Total weight</span>
      <span data-testid="sfg-filter-total-kg" className="font-mono-data text-lg font-bold">
        {totalKg.toLocaleString("en-IN", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} kg
      </span>
      <span data-testid="sfg-filter-total-count" className="text-xs opacity-70 font-mono-data">· {count} coil{count !== 1 ? "s" : ""}</span>
    </div>
  </div>
);
